const WhenOutletLoadedMixin = {

    data() {
        return {
            outlet_first_load: true,
        }
    },

    mounted(){

        if (this.outlet){
            this.fireWhenOutletLoaded()
        }
    },

    methods: {

        fireWhenOutletLoaded() {
            const copy_outlet_first_load = this.outlet_first_load
            if (copy_outlet_first_load == true)
                this.outlet_first_load = false

            return this.whenOutletLoaded(copy_outlet_first_load)
        },

        whenOutletLoaded(first_load) {

        }
    },

    watch: {
        outlet: function(new_outlet, old_outlet){
            if (new_outlet != null) {
                this.fireWhenOutletLoaded()
            }
        }
    }
}

export default WhenOutletLoadedMixin


// WEBPACK FOOTER //
// ./src/js/mixins/whenoutletloaded.js